"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var InstructorCreateShiftModalInstanceController = /** @class */ (function () {
    function InstructorCreateShiftModalInstanceController($scope, $state, $uibModalInstance, BatchCreateService, FlashService, ToasterService) {
        var _this = this;
        this.$scope = $scope;
        this.$state = $state;
        this.$uibModalInstance = $uibModalInstance;
        this.BatchCreateService = BatchCreateService;
        this.FlashService = FlashService;
        this.ToasterService = ToasterService;
        this.updateEndDate = this.updateEndDate.bind(this);
        this.drive = (0, cloneDeep_1.default)(BatchCreateService.getDrive());
        this.drive.sectors = this.drive.sectors.filter(function (sector) {
            return !sector === false;
        });
        this.context = BatchCreateService.getContext();
        this.drives = [];
        this.today = new Date();
        this.endDate = (0, cloneDeep_1.default)(this.drive).date;
        delete this.drive.notes; // remove notes for batches/shift
        this.drives.push(this.drive);
        this.datepicker = {
            open: function ($event) {
                _this.datepicker.status.opened = true;
            },
            dateOptions: {
                formatYear: "yy",
                startingDay: 7,
                showWeeks: false,
                minDate: this.drives[0].date,
            },
            format: "dd-MMMM-yyyy",
            status: {
                opened: false,
            },
        };
    }
    InstructorCreateShiftModalInstanceController.prototype.addDriveToShift = function () {
        var oldDrive = (0, cloneDeep_1.default)(this.drives[this.drives.length - 1]);
        var newDrive = (0, cloneDeep_1.default)(this.drives[this.drives.length - 1]);
        newDrive.time = (0, time_1.addMinutes)((0, time_1.addHours)(oldDrive.time, oldDrive.length.hours), oldDrive.length.minutes);
        this.drives.push(newDrive);
    };
    InstructorCreateShiftModalInstanceController.prototype.removeDriveFromShift = function ($index) {
        this.drives.splice($index, 1);
    };
    InstructorCreateShiftModalInstanceController.prototype.ok = function () {
        this.$uibModalInstance.close(this.$scope.selected.item);
    };
    InstructorCreateShiftModalInstanceController.prototype.cancel = function () {
        this.$uibModalInstance.dismiss("cancel");
    };
    /**
     * Prevents creating a shift with sessions that run into one another
     * @param index
     * @returns {*}
     */
    InstructorCreateShiftModalInstanceController.prototype.calculateMinTime = function (index) {
        var min;
        if (index === 0) {
            return;
        }
        min = (0, time_1.addMinutes)((0, time_1.addHours)(this.drives[index - 1].time, this.drives[index - 1].length.hours), this.drives[index - 1].length.minutes);
        if (index + 1 !== this.drives.length) {
            var max = this.drives[index + 1].time;
            var endTime = (0, time_1.addMinutes)((0, time_1.addHours)(this.drives[index].time, this.drives[index].length.hours), this.drives[index].length.minutes);
            var possibleMax = (0, time_1.subtractMinutes)((0, time_1.subtractHours)(this.drives[index + 1].time, this.drives[index + 1].length.hours), this.drives[index + 1].length.minutes);
            if ((0, time_1.isAfter)(endTime, max)) {
                this.drives[index].time = possibleMax;
            }
        }
        if ((0, time_1.isBefore)(this.drives[index].time, min)) {
            this.drives[index].time = min;
        }
    };
    InstructorCreateShiftModalInstanceController.prototype.updateEndDate = function (newDate) {
        this.endDate = newDate.selected[0];
    };
    InstructorCreateShiftModalInstanceController.prototype.createShift = function () {
        var _this = this;
        this.submitting = true;
        var endDate = (0, time_1.toYMD)(this.endDate);
        var template = (0, cloneDeep_1.default)(this.drives[0]);
        var location = template.location;
        delete location.sectors;
        delete location.zoneparts;
        delete location.zones;
        var sectors = template.sectors.map(function (sector) {
            delete sector.geom;
            return {
                id: sector.id,
            };
        });
        var instructor = template.instructor;
        var vehicle = template.vehicle;
        var drives = (0, cloneDeep_1.default)(this.drives).map(function (drive) {
            var time = drive.time;
            var date = drive.date;
            drive.date = (0, time_1.toYMD)(date);
            drive.formatDate = (0, time_1.toYMD)(date);
            drive.time = (0, time_1.formatDateTime)(time, "HH:mm");
            drive.formatTime = (0, time_1.formatDateTime)(time, "HH:mm");
            delete drive.sectors;
            delete drive.instructor;
            delete drive.location;
            delete drive.vehicle;
            return drive;
        });
        this.BatchCreateService.getBatchMethod({
            drives: drives,
            end_date: endDate,
            days: this.days,
            sectors: sectors,
            instructor: instructor,
            location: location,
            vehicle: vehicle,
        }, this.context)
            .then(function (response) {
            _this.ToasterService.addToast({
                type: "success",
                message: response.message,
            });
            _this.BatchCreateService.setDrive(null);
            _this.$uibModalInstance.dismiss("cancel");
            _this.submitting = false;
            _this.$state.go("drivecoach.instructor.dashboard", {}, { reload: true });
        })
            .catch(function (Error) {
            _this.submitting = false;
        });
    };
    return InstructorCreateShiftModalInstanceController;
}());
InstructorCreateShiftModalInstanceController.$inject = [
    "$scope",
    "$state",
    "$uibModalInstance",
    "BatchCreateService",
    "FlashService",
    "ToasterService",
];
exports.default = InstructorCreateShiftModalInstanceController;
